<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex class="d-flex justify-space-between mb-3 align-center" xs12>
        <h3 class="font-weight-bold">Traveller Report</h3>
        <div class="text-xs-right">
          <export-summary-report-button model="traveller-countrywise" :export-country="country"
                                        :export-date="range"
                                        :passport-type="passport_type"
                                        v-if="$oauth.checkIfHasPermission(['export traveller-summary-report'])"/>
          <refresh-button :click-function="travellerSummaryReport"></refresh-button>
        </div>
      </v-flex>
      <v-flex xs12>

        <v-card>
          <v-layout class="py-1 mx-2" row wrap>
            <!--                        <v-flex xs3 class="d-flex align-center">-->
            <!--                            <custom-date-range-picker @change="travellerSummaryReport"-->
            <!--                                                      v-model="range"/>-->
            <!--                        </v-flex>-->
            <!--                        <v-flex xs4>-->
            <!--                            <v-autocomplete-->
            <!--                                    :items="passport_types"-->
            <!--                                    chips-->
            <!--                                    clearable-->
            <!--                                    deletable-chips-->
            <!--                                    flat-->
            <!--                                    hide-details-->
            <!--                                    label="Passport types"-->
            <!--                                    multiple-->
            <!--                                    prepend-inner-icon="filter_list"-->
            <!--                                    solo-->
            <!--                                    v-model="passport_type"-->
            <!--                                    @change="travellerSummaryReport"-->
            <!--                            />-->
            <!--                        </v-flex>-->
            <v-flex xs6>
              <v-autocomplete
                  :items="countries"
                  chips
                  clearable
                  deletable-chips
                  flat
                  hide-details
                  item-text="country_name"
                  item-value="id"
                  label="Countries"
                  multiple
                  prepend-inner-icon="filter_list"
                  solo
                  v-model="country"
                  @change="travellerSummaryReport"
              />
            </v-flex>
            <!--                        <v-flex xs3>-->
            <!--                            <v-autocomplete-->
            <!--                                    :items="offices"-->
            <!--                                    clearable-->
            <!--                                    flat-->
            <!--                                    hide-details-->
            <!--                                    item-text="name"-->
            <!--                                    item-value="id"-->
            <!--                                    label="Office"-->
            <!--                                    prepend-inner-icon="filter_list"-->
            <!--                                    solo-->
            <!--                                    v-model="office"-->
            <!--                                    @change="travellerSummaryReport"-->
            <!--                            />-->
            <!--                        </v-flex>-->

          </v-layout>

          <v-divider/>
          <v-card-text class="pa-0">
            <!--                        <v-data-table-->
            <!--                            :headers="headers"-->
            <!--                            :items="country_wise_data"-->
            <!--                            :loading="loading"-->
            <!--                            :options.sync="pagination"-->
            <!--                            :footer-props="footerProps"-->
            <!--                            class="elevation-0"-->
            <!--                            v-if="$oauth.checkIfHasPermission(['read arrival-departure-summary-report'])"-->
            <!--                            hide-default-footer>-->

            <!--                        </v-data-table>-->
            <v-simple-table
                class="elevation-0 pb-6"
                v-if="$oauth.checkIfHasPermission(['read traveller-summary-report'])"
            >
              <thead>
              <!--                            <v-progress-linear-->
              <!--                                :active="progressLinearLoading"-->
              <!--                                :indeterminate="progressLinearLoading"-->
              <!--                                absolute-->
              <!--                                bottom-->
              <!--                                color="primary"-->
              <!--                            ></v-progress-linear>-->
              <v-overlay :value="progressLinearLoading">
                <v-progress-circular
                    indeterminate
                    size="64"
                ></v-progress-circular>
              </v-overlay>
              <tr>
                <th class="text-center">S.N</th>
                <th>Nationality</th>
                <th class="text-center">Male</th>
                <th class="text-center">Female</th>
                <th class="text-center">Other</th>
                <th class="text-center">Total</th>
              </tr>
              </thead>
              <tbody v-if="country_wise_data">
              <tr v-for="(item,i) in country_wise_data">
                <td class="text-center">{{ i + 1 }}</td>
                <td class="text-center">{{ item.nationality }}</td>
                <td class="text-center">{{ item.male_traveller }}</td>
                <td class="text-center">{{ item.female_traveller }}</td>
                <td class="text-center">{{ item.other_traveller }}</td>
                <td class="text-center font-weight-bold">{{ item.total }}</td>
              </tr>
              </tbody>
              <tbody v-else>
              <tr>
                <td><h3 class="text-center">No record found</h3></td>
              </tr>
              </tbody>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import CustomDateRangePicker from "../../components/CustomDateRangePicker";
import {commonStoreMixin} from "../../mixins/commonStoreMixin";
import IssuedVisaFooter from "../../components/footer/IssuedVisaFooter";
import ExportSummaryReportButton from "../../components/ExportSummaryReportButton";
import Http from "axios";
import {VERSIONED_API_URL} from "../../config/config";
import RefreshButton from "@/components/RefreshButton";

const TRAVELLER_SUMMARY_REPORT_URL = `${VERSIONED_API_URL}/summary-report/traveller-countrywise`;

export default {
  name: "ADCountryWiseReport",
  data() {
    return {
      ADTypes: [
        "Arrival",
        "Departure",
        "Arrival Cancel",
        "Departure Cancel",
      ],
      country_wise_data: [],
      country_wise_arrival: [],
      country_wise_departure: [],
      office: null,
      passport_type: null,
      passport_types: ['Ordinary passport', 'Diplomatic Passport', 'Official/Service Passport', 'Laissez-passer Passport', 'Crew Passport'],
      range: {},
      country: [],
      table_data: []
    };
  },
  components: {RefreshButton, CustomDateRangePicker, IssuedVisaFooter, ExportSummaryReportButton},
  mixins: [commonStoreMixin],
  computed: {
    ...mapGetters({
      loading: "ArrivalDepartureReport/reportLoading",
      countries: "CountryList/all",
      officers: "UserList/all"
    }),
    from_main_office() {
      return this.$store.state.AuthUser.user.from_main_office;
    },
    offices() {
      return this.$store.state.OfficeList.offices;
    }
  },
  methods: {
    ...mapActions({
      fetchCountries: "CountryList/fetchAllCountries",
      fetchOfficers: "UserList/getAll"
    }),
    travellerSummaryReport() {
      let params = {};
      this.progressLinearLoading = true;
      if (this.range)
        params.date_range = this.range;
      if (this.country)
        params.country = this.country;

      if (this.office)
        params.office_id = this.office

      if (this.passport_type)
        params.passport_type = this.passport_type


      Http.get(TRAVELLER_SUMMARY_REPORT_URL, {
        params: params
      })
          .then((res) => {
            this.country_wise_data = res.data.data;
            this.progressLinearLoading = false;
            // this.getData();
          })
          .catch(() => {
            this.$store.commit('Notification/showError', 'Something went wrong');
            this.progressLinearLoading = false;
          });
    }


  },
  mounted() {
    if (this.$store.state.CountryList.all.length === 0) {
      this.fetchCountries();
    }
    this.progressLinearLoading = true;
    Http.get(TRAVELLER_SUMMARY_REPORT_URL)
        .then((res) => {
          this.country_wise_data = res.data.data;
          this.progressLinearLoading = false;
          // this.getData();
        })
        .catch(() => {
          this.progressLinearLoading = false;
        });

    // this.$store.dispatch("OfficeList/fetchData");

    this.range = {
      start: new Date().toISOString().substr(0, 10),
      end: new Date().toISOString().substr(0, 10)
    }
  }
}
</script>

